import { translations } from "../translate";

export const LEGAL_PRIVACY_BLOCKS = {
  LEGAL_AND_PRIVACY: "legal-and-privacy",
  TERMS_OF_USE: "terms-of-use",
  PRIVACY_STATEMENT: "privacy-statement",
  COPYRIGHT_INFRINGEMENT_NOTIF: "copyright-infringement-notification",
  NON_DISCRIMINATION_NOTICE: "non-discrimination-notice",
  MEDICAL_AND_PAYMENT_POLICIES: "medical-policies-and-payment-and-coding-policies",
};

export const LEGAL_PRIVACY_BLOCKS_VALUES = Object.values(LEGAL_PRIVACY_BLOCKS);

export const legalAndPrivacyLinks = (stateUSACode: string, language: "en" | "es") => [
  {
    value: LEGAL_PRIVACY_BLOCKS.LEGAL_AND_PRIVACY,
    label: translations.legaAndPrivacy[language],
  },
  { value: LEGAL_PRIVACY_BLOCKS.TERMS_OF_USE, label: translations.termsOfUse[language] },
  {
    value: LEGAL_PRIVACY_BLOCKS.PRIVACY_STATEMENT,
    label: translations.privacyStatement[language],
  },
  {
    value: LEGAL_PRIVACY_BLOCKS.COPYRIGHT_INFRINGEMENT_NOTIF,
    label: translations.copyInfNotif[language],
  },
  {
    value: LEGAL_PRIVACY_BLOCKS.NON_DISCRIMINATION_NOTICE,
    label: translations.NonDiscrimination[language],
  },
  ...(stateUSACode === "tx"
    ? [
        {
          value: LEGAL_PRIVACY_BLOCKS.MEDICAL_AND_PAYMENT_POLICIES,
          label: translations.medPolices[language],
        },
      ]
    : []),
];
